export class PolicyAcceptance extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.privacyContent = this.dataset.privacy_content;
        this.privacyTitle = this.dataset.privacy_title;
        this.privacyInstructions = this.dataset.privacy_instructions;
        this.termsContent = this.dataset.terms_content;
        this.termsTitle = this.dataset.terms_title;
        this.termsInstructions = this.dataset.terms_instructions;
        this.uid = this.dataset.uid;
        this.needsPrivacy = parseInt(this.dataset.needs_privacy);
        this.needsTerms = parseInt(this.dataset.needs_terms);

        delete this.dataset.privacy_content;
        delete this.dataset.terms_content;
        delete this.dataset.privacy_title;
        delete this.dataset.terms_title;
        delete this.dataset.uid;
        delete this.dataset.needs_privacy;
        delete this.dataset.needs_terms;
        delete this.dataset.privacy_instructions;
        delete this.dataset.terms_instructions;

        this.init();
    }

    init() {
        this.createDialog();
        this.populateDialog();

        this.initEventHandlers();

        this.dialog.showModal();
    }

    createDialog() {
        this.dialog = document.createElement("dialog");
        this.dialog.classList.add("modal-dlg");
        this.dialog.id = "policy-agreement-dialog";

        const dlgContent = document.createElement("div");
        dlgContent.classList.add("dlg-content");
        this.dialog.appendChild(dlgContent);

        const dlgHeader = document.createElement("div");
        dlgHeader.classList.add("dlg-header");
        dlgContent.appendChild(dlgHeader);
        this.dlgHeading = document.createElement("h2");
        this.dlgHeading.textContent = "Privacy Agreement";
        dlgHeader.appendChild(this.dlgHeading);
		const closeBtn = document.createElement("a");
        closeBtn.id = 'dialog-close-btn';
        closeBtn.href = "/user/logout";
		dlgHeader.appendChild(closeBtn);
        closeBtn.classList.add("close-btn");
        closeBtn.textContent = "X";

        this.dlgBody = document.createElement("div");
        this.dlgBody.classList.add("dlg-body");
        dlgContent.appendChild(this.dlgBody);

        const dlgFooter = document.createElement("div");
        dlgFooter.classList.add("dlg-footer");
        dlgContent.appendChild(dlgFooter);
        this.dlgInstructions = document.createElement("p");
        this.dlgInstructions.classList.add("policy-instructions");
        dlgFooter.appendChild(this.dlgInstructions);

        const btnDiv = document.createElement("div");
        btnDiv.classList.add("btn-div");
        dlgFooter.appendChild(btnDiv);
        const acceptBtn = document.createElement("button");
        acceptBtn.classList.add("accept-btn");
        acceptBtn.id = "accept-policy-button";
        acceptBtn.textContent = "Accept + Close";
        btnDiv.appendChild(acceptBtn);

        const rejectBtn = document.createElement("a");
        rejectBtn.classList.add("reject-btn");
        rejectBtn.id = "reject-policy-button";
        rejectBtn.href = "/user/logout";
        rejectBtn.textContent = "Reject + Log Out";
        btnDiv.appendChild(rejectBtn);



        document.body.appendChild(this.dialog);
    }

    populateDialog() {
        if (this.needsPrivacy) {
            this.dlgHeading.textContent = this.privacyTitle;
            this.dlgBody.innerHTML = this.privacyContent;
            this.dlgInstructions.textContent = this.privacyInstructions;
            this.policyType = "privacy";
            this.dialog.classList.add('privacy');
        } else if (this.needsTerms) {
            this.dlgHeading.textContent = this.termsTitle;
            this.dlgBody.innerHTML = this.termsContent;
            this.dlgInstructions.textContent = this.termsInstructions;
            this.policyType = "terms";
            this.dialog.classList.add('terms');
        }
    }

    initEventHandlers() {
        this.onShowModal = this.onShowModal.bind(this);
        this.dialog.addEventListener("show.bs.modal", this.onShowModal);

        this.onHideModal = this.onHideModal.bind(this);
		this.dialog.addEventListener("hide.bs.modal", this.onHideModal);
		
		this.closeModal = this.closeModal.bind(this);
		const closeBtn = this.dialog.querySelector('#dialog-close-btn');
		closeBtn.addEventListener('click', this.closeModal);

        this.onClickAcceptAndClose = this.onClickAcceptAndClose.bind(this);
        const acceptBtn = this.dialog.querySelector("button#accept-policy-button");
        acceptBtn.addEventListener("click", this.onClickAcceptAndClose);

        this.onClickRejectAndLogout = this.onClickRejectAndLogout.bind(this);
        const rejectBtn = this.dialog.querySelector("a#reject-policy-button");
        rejectBtn.addEventListener("click", this.onClickRejectAndLogout);

        this.onCancel = this.onCancel.bind(this);
        this.dialog.addEventListener("cancel", this.onCancel);
    }

    removeEventHandlers() {
        this.dialog.removeEventListener("show.bs.modal", _self.onShowModal);

        this.dialog.removeEventListener("hide.bs.modal", _self.onHideModal);
    }

    onShowModal(event) {
        const _self = this;
    }

    onHideModal(event) {
        const _self = this;
    }

    onClickAcceptAndClose(event) {
        const userID = this.uid;
        const formData = new FormData();
        formData.append("userID", userID);
        formData.append("policyType", this.policyType);
        // update user's record with the policy acceptance date
        fetch("/user/update-policy-acceptance", {
            method: "post",
            body: formData,
        }).then((response) => {
            if (response.ok) {
                toastr.success("Thank you for accepting our " + (this.policyType == 'privacy' ? 'Privacy' : 'Terms of Use') + " Policy");
            } else {
                toastr.error(
                    "Something went wrong while updating our records...  You will be required to accept our latest " +  (this.policyType == 'privacy' ? 'Privacy' : 'Terms of Use') + " policy again."
                );
			}
			
			this.dialog.close();

            this.checkForAdditionalAcceptance();
        });

	}
    onClickRejectAndLogout()
    {
        this.dialog.close();
        
    }
	
	closeModal()
	{
		this.dialog.close();
    }

	onCancel(event)
	{
		event.preventDefault();
		window.location.href = "/user/logout";
	}

	checkForAdditionalAcceptance()
	{
		if (this.policyType == 'privacy' && this.needsTerms) {
			setTimeout(() => {
				this.dlgHeading.textContent = this.termsTitle;
                this.dlgBody.innerHTML = this.termsContent;
                this.dlgInstructions.textContent = this.termsInstructions;
                this.dialog.showModal();
                this.policyType = "terms";
                this.dialog.classList.remove('privacy');
                this.dialog.classList.add('terms');
			}, 1000);
			// now need to show the terms dialog.
		}
	}
}

customElements.define('policy-acceptance', PolicyAcceptance);
